import { sprintf } from 'sprintf-js';
export const isRequiredMsg = (...args)=> sprintf("The %s field is required", ...args);
export const isPasswordMsg = (...args)=> sprintf("Your %s must contains min 8 characters include (. ! -) and contains one uppercase character or number.", ...args);
export const isConfirmMsg = (...args)=> sprintf("The %s field and %s field doesnt same.", ...args);